// extracted by mini-css-extract-plugin
export default {"eye__icon":"styles_eye__icon__o6Io+","form__container":"styles_form__container__csndn","forget-password__text":"styles_forget-password__text__SHVGw"};